/** @format */

//Selectors
export const selectUserRole = (state): String => state.role.role;
